document.addEventListener('DOMContentLoaded', function() {
  var carousels = document.querySelectorAll("[data-init-carousel].swiper-container");
  carousels.forEach((carousel) => {
    new Swiper(carousel, {
      direction: "horizontal",
      slidesPerView: 5,
      speed: 1000,
      breakpoints: {
        320: {
          slidesPerView: 1.5,
        },
        375: {
          slidesPerView: 1.75,
        },
        425: {
          slidesPerView: (carousel.getAttribute("data-mobile-slides-per-view")) ? carousel.getAttribute("data-mobile-slides-per-view")  : 2.75
        },
        768: {
          slidesPerView: (carousel.getAttribute("data-tablet-slides-per-view")) ? carousel.getAttribute("data-tablet-slides-per-view") : 3.5
        },
        1100: {
          slidesPerView: (carousel.getAttribute("data-desktop-slides-per-view")) ? carousel.getAttribute("data-desktop-slides-per-view") : 5
        },
      },
  
      // Navigation arrows
      navigation: {
        nextEl: `.swiper-button-next-${carousel.getAttribute("data-id")}`,
        prevEl: `.swiper-button-prev-${carousel.getAttribute("data-id")}`,
      },
    });
  });
});

